import React from "react";
import { Layout, NftTokenComp } from "../components";

const NftTokenPage = () => {
  return (
    <>
      <Layout>
        <NftTokenComp />
      </Layout>
    </>
  );
};

export default NftTokenPage;
